<section class="admin-page ct-page ai-mkt">
  <div class="ct-toolbar">
    <div>
      <p class="subtitle">{{ 'aiMarketing.hub.subtitle' | t }}</p>
    </div>
  </div>

  @if (loading()) {
    <div class="ct-card"><p>{{ 'common.loading' | t }}</p></div>
  } @else if (loadError()) {
    <div class="ct-card">
      <p class="text-danger">{{ loadError() }}</p>
      <button type="button" class="ct-btn ct-btn-sm ct-btn-primary" (click)="reload()">
        {{ 'common.retry' | t }}
      </button>
    </div>
  } @else {
    <div class="ct-card ct-table-wrap">
      <table class="ct-table ai-mkt-tools-table">
        <thead>
          <tr>
            <th class="col-tool">{{ 'aiMarketing.hub.toolsCol' | t }}</th>
            <th class="col-desc">{{ 'aiMarketing.hub.descCol' | t }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="col-tool">{{ 'aiMarketing.nav.creatives' | t }}</td>
            <td class="col-desc muted">{{ 'aiMarketing.hub.creativesDesc' | t }}</td>
            <td class="actions">
              <button type="button" class="ct-btn ct-btn-navy ct-btn-sm" routerLink="/admin/ai-marketing/creatives">
                {{ 'aiMarketing.hub.open' | t }}
              </button>
            </td>
          </tr>
          <tr>
            <td class="col-tool">{{ 'aiMarketing.nav.organic' | t }}</td>
            <td class="col-desc muted">{{ 'aiMarketing.hub.organicDesc' | t }}</td>
            <td class="actions">
              <button type="button" class="ct-btn ct-btn-navy ct-btn-sm" routerLink="/admin/ai-marketing/organic">
                {{ 'aiMarketing.hub.open' | t }}
              </button>
            </td>
          </tr>
          <tr>
            <td class="col-tool">{{ 'aiMarketing.nav.assistant' | t }}</td>
            <td class="col-desc muted">{{ 'aiMarketing.hub.assistantDesc' | t }}</td>
            <td class="actions">
              <button type="button" class="ct-btn ct-btn-navy ct-btn-sm" routerLink="/admin/ai-marketing/assistant">
                {{ 'aiMarketing.hub.open' | t }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="ct-toolbar connections-head">
      <div>
        <p class="subtitle">{{ 'aiMarketing.integrations.subtitle' | t }}</p>
        <p class="muted small">{{ 'aiMarketing.integrations.onePerBusiness' | t }}</p>
      </div>
    </div>

    <div class="ct-card ct-table-wrap ai-mkt-integrations-table">
      <table class="ct-table">
        <thead>
          <tr>
            <th>{{ 'aiMarketing.integrations.channel' | t }}</th>
            <th>{{ 'common.status' | t }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ 'aiMarketing.integrations.meta' | t }}</td>
            <td>
              @if (needsAccountSelection()) {
                <span class="muted">{{ 'aiMarketing.connection.needsSelection' | t }}</span>
              } @else if (!hasAnyConnection()) {
                <span class="muted">{{ 'aiMarketing.connection.notConnected' | t }}</span>
              } @else {
                <ul class="meta-status-list">
                  <li>
                    <span class="muted">{{ 'aiMarketing.integrations.facebook' | t }}:</span>
                    @if (isConnected(integrations()?.facebookPage)) {
                      <span>{{ integrations()?.facebookPage?.name }}</span>
                    } @else {
                      <span class="muted">{{ 'aiMarketing.integrations.notConnected' | t }}</span>
                    }
                  </li>
                  <li>
                    <span class="muted">{{ 'aiMarketing.integrations.instagram' | t }}:</span>
                    @if (isConnected(integrations()?.instagram)) {
                      <span>{{ '@' + (integrations()?.instagram?.username || integrations()?.instagram?.name || '') }}</span>
                    } @else {
                      <span class="muted">{{ 'aiMarketing.integrations.notConnected' | t }}</span>
                    }
                  </li>
                </ul>
              }
              <p class="muted small">{{ 'aiMarketing.integrations.metaHint' | t }}</p>
            </td>
            <td class="actions ai-mkt-meta-actions">
              @if (needsAccountSelection()) {
                <button
                  type="button"
                  class="ct-btn ct-btn-sm ct-btn-primary"
                  (click)="openConnectModal({ resume: true })"
                >
                  {{ 'aiMarketing.connection.continue' | t }}
                </button>
              } @else if (hasAnyConnection()) {
                <button
                  type="button"
                  class="ct-btn ct-btn-sm ct-btn-primary"
                  (click)="openConnectModal({ reconnect: true })"
                >
                  {{ 'aiMarketing.integrations.reconnect' | t }}
                </button>
                <button type="button" class="ct-btn ct-btn-ghost ct-btn-sm ai-mkt-disconnect" (click)="disconnectMeta()">
                  {{ 'aiMarketing.connection.disconnect' | t }}
                </button>
              } @else {
                <button type="button" class="ct-btn ct-btn-sm ct-btn-primary" (click)="openConnectModal()">
                  {{ 'aiMarketing.connection.connectMeta' | t }}
                </button>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  }
</section>

@if (connectModalOpen()) {
  <div class="ct-dialog-backdrop" (click)="closeConnectModal()">
    <div
      class="ct-dialog ai-mkt-connect-dialog"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="'ai-mkt-connect-title'"
      (click)="$event.stopPropagation()"
      (keydown.escape)="closeConnectModal()"
    >
      <header class="ct-dialog-head">
        <h2 id="ai-mkt-connect-title">{{ 'aiMarketing.connect.title' | t }}</h2>
        <button
          type="button"
          class="ct-dialog-close"
          (click)="closeConnectModal()"
          [attr.aria-label]="'common.close' | t"
        >
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>
      </header>
      <div class="ct-dialog-body">
        <p class="subtitle">{{ 'aiMarketing.connect.subtitleWizard' | t }}</p>
        <app-ai-marketing-connect
          [reconnect]="connectReconnect()"
          [resumeAfterAuth]="connectResume()"
          (authorized)="onConnectAuthorized()"
          (completed)="onConnectCompleted()"
        />
      </div>
    </div>
  </div>
}
